import { Drawer } from 'antd'
import React, { useState, useEffect } from 'react'
import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { getUser } from '../../reducers/UserReducer'
import { getContactPersonSpecialitiesByInstitution } from '../../utils/api/users'
import SmartTable, { DATA_TYPE_STRING } from './SmartTable'

const mapStateToProps = state => {
  return {
    t: getTranslate(state.locale),
    getUser: getUser(state.getUser)
  }
}

const ContactPersonSpecialitiesInstitutionWidget = props => {
  const [contactPersonSpecialityYears, setContactPersonSpecialityYears] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (props.user !== null && props.getUser !== null) {
      getContactPersonSpecialitiesByInstitution(props.user, props.institution, props.getUser)
        .then(data => {
          data.map(specialityYear => {
            specialityYear.name = specialityYear.specialityAbbreviation + ' (' + specialityYear.studyYearName + ')'
          })

          setContactPersonSpecialityYears(data)
          setLoading(false)
        })
    }
  }, [props.user, props.getUser])

  const COLUMNS = [
    {
      type: DATA_TYPE_STRING,
      name: props.t('Specialities'),
      key: 'name'
    }
  ]

  return (
    <Drawer
      title={props.user !== null ? props.t('Specialities managed by') + ' ' + props.user.email : '?'}
      width='640px'
      onClose={props.onClose}
      visible={props.user !== null}
    >
      <SmartTable
        loading={loading}
        columns={COLUMNS}
        data={contactPersonSpecialityYears}
        noDataText={props.t('Without speciality')}
      />
    </Drawer>
  )
}

export default connect(mapStateToProps)(ContactPersonSpecialitiesInstitutionWidget)
